import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { AteneaModule, MaterialModule } from "@atenea-cms";
import { ResellersRoutes } from "./resellers.routes";
import { ResellerFilterBarComponent } from "./reseller-filter-bar/reseller-filter-bar.component";
import { ResellerListComponent } from "./reseller-list/reseller-list.component";
import { ResellerDetailComponent } from "./reseller-detail/reseller-detail.component";
import {
  ResellerService,
  ResellerFormService,
  ResellerFilterPipe,
} from "./shared";

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    AteneaModule,
    MaterialModule,
    ResellersRoutes,
  ],
  declarations: [
    ResellerFilterBarComponent,
    ResellerListComponent,
    ResellerDetailComponent,
    ResellerFilterPipe,
  ],
  providers: [ResellerService, ResellerFormService],
})
export class ResellersModule {}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/resellers/resellers.module.ts